import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    CircularProgress,
    Fab,
    Typography,
    Paper,
    Grid,
} from '@material-ui/core';

import { Error as ErrorIcon } from '@material-ui/icons';

import { Button } from 'devextreme-react';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
    overlay: {
        display: 'flex',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.16)',
        borderRadius: '4px'
    },
    circle: {
        color: '#fff',
    },
    paperError: {
        width: '280px',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    message: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '10px 20px 10px 20px !important'
    },
    buttonErrored: {
        backgroundColor: '#d9534f',
        '&:hover': {
            backgroundColor: '#ce312c',
        },
    },
});

const ErrorCmp = props => {
    const { classes, cancelActions, tryAgainAction, errorMessage } = props;

    return (

        <Paper className={classes.paperError}>
            <Grid container spacing={3} >

                <Grid item xs={12} className={classes.alignCenter}>
                    <Fab
                        aria-label="save"
                        color="primary"
                        className={classes.buttonErrored}
                    >
                        <ErrorIcon />
                    </Fab>
                </ Grid>

                <Grid item xs={12} className={classes.message}>
                    <Typography variant="subtitle1" >
                        {errorMessage !== undefined ? errorMessage :
                            "Ops. L'operazione non è andata a buon fine."
                        }
                    </Typography>
                </ Grid>

                <Grid item xs={12} >
                    <Grid container spacing={1} >
                        <Grid item xs={6} className={classes.alignCenter}>
                            <Button
                                width={120}
                                text="Indietro"
                                type="normal"
                                stylingMode="outlined"
                                onClick={() => cancelActions()}
                            />
                        </ Grid>

                        <Grid item xs={6} className={classes.alignCenter} >
                            <Button
                                width={120}
                                text="Riprova"
                                type="default"
                                stylingMode="contained"
                                onClick={() => tryAgainAction()}
                            />
                        </ Grid>
                    </ Grid>
                </Grid>

            </ Grid>
        </Paper>

    );
};

//NB: quando si utilizza Progress, aggiungere position: 'relative' nel css del container nel quale verrà inserito

class Progress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            errored: false,

            showErrorActions: false,
        };

        this.cancelActions = this.cancelActions.bind(this);
        this.tryAgain = this.tryAgain.bind(this);
    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.status !== propsPrecedenti.status) {

            if (this.props.status === 'PENDING') {
                this.setState(prevState => ({
                    ...prevState,
                    loading: true,
                    errored: false,
                }),
                    () => {
                        // this.props.eseguiQualcosa());
                    }
                );
            }            

            if (this.props.status === 'ERRORED') {

                setTimeout(() => {
                    this.setState(prevState => ({
                        ...prevState,
                        loading: false,
                        errored: true,
                    }),
                        () => {
                            // se tryAgainAction è definita, mostro i bottoni "Indietro" e "Riprova"
                            if (this.props.tryAgainAction !== undefined)
                                this.setState(prevState => ({
                                    ...prevState,
                                    showErrorActions: true,
                                }));
                            // altrimenti setto timer che faccia dissolvere Progress automaticamente
                            else
                                setTimeout(() => {
                                    this.setState(prevState => ({
                                        ...prevState,
                                        loading: false,
                                    }));
                                }, 1000);
                        }
                    );
                }, 1000);
            }
        }
    }

    cancelActions() {

        this.props.cancelAction();

        this.setState({
            showErrorActions: false,
            errored: false,
        });
    }

    tryAgain() {
        this.setState({
            loading: true,
            errored: false,
        });

        this.props.tryAgainAction();
    }


    render() {
        const { classes, errorMessage } = this.props;
        const { loading, errored, showErrorActions } = this.state;


        return (
            <div className={classes.overlay}>                
                {loading && 
                    <CircularProgress size={50} className={classes.circle} />
                }
                {errored && showErrorActions &&
                    <ErrorCmp
                        cancelActions={this.cancelActions}
                        tryAgainAction={this.tryAgain}
                        classes={classes}
                        errorMessage={errorMessage}
                    />
                }
            </div>
        );
    }
}

Progress.propTypes = {
    status: PropTypes.string.isRequired,


    cancelAction: PropTypes.func.isRequired,
    tryAgainAction: PropTypes.func.isRequired,
    errorMessage: PropTypes.string
};

export default withStyles(styles)(Progress);